module.exports = __webpack_public_path__ + "img/mvp_girl_2024.d61bd3b1.jpg";